import React from 'react';
import { withRouter, Redirect } from 'react-router-dom'
import css from './Edit.module.css';

import FolderTree from '../components/FolderTree';

import {
  Container,
  Grid,
  Button,
  FormControl,
} from '@material-ui/core';


class Move extends React.Component {
  constructor(props) {
    super(props);
    
    this.state = {
      files: this.getFilesArray(this.props.location.state.files),
      date: null,
      people: '',
      clinicCode: [],
      category: [],
      description: '',
      folderPrefix: '',
      folderId: '0',
      folderHash: {},
      done: false,
    };
  }

  getFilesArray = (files) => {
    const filesArray = [];
    for(const key in files)
      filesArray.push(files[key]);
    return filesArray;
  }

  folderOnInit = ({ hash }) => {
    this.setState({ folderHash: hash });
  };

  folderOnSelect = (folderPrefix, folderId) => {
    this.setState({ folderPrefix: folderPrefix, folderId: folderId, });
  }

  moveItem = (sourcePath, destinationPath) => {
    return new Promise(async (resolve, reject) => {
      try {
        let params = { source_path: sourcePath, destination_path: destinationPath };
        let endpoint = `/api/move`;
        let response = await fetch(endpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(params),
        });
        let results = await response.json();
        return resolve(results);
      }
      catch(err) {
        return reject();
      }
    });
  }

  handleFormSubmit = async (e) => {
    e.preventDefault();
    this.props.alert('Confirm Move', 'Are you sure you want to move these files?', false, this.alertSubmitCallback);
  }

  alertSubmitCallback = async (result) => {
    if(!result)
      return this.props.alert('Move Canceled');

    let files = this.state.files;

    let noti = {
      id: `move-${(new Date()).toISOString()}`,
      title: `Moving Files`,
      message: `0/${files.length} files moved`,
      status: 'pending',
      progress: 0,
    };
    await this.props.notiActions.add(noti);

    let newFolderPrefix = this.state.folderPrefix;
    console.log(`Moving files to folder: ${newFolderPrefix}`);
    console.log(files);

    this.props.alert(`Moving ${files.length} File(s)`, 'Please check the notification area for progress');
    this.setState({ done: true });

    for(let i = 0; i < files.length; ++i) {
      let file = files[i];
      let oldPath = file.path;
      let newPath =  newFolderPrefix + file.fileName;

      console.log(`Moving file ${file.path} from ${oldPath} to ${newPath}`);

      try {
        let res = await this.moveItem(oldPath, newPath);
        console.log(res);
      } catch(err) {
        console.log(err);
        let errNoti;
        // Handle 50x errors, we assume it is a gateway timeout
        if(err && !err.response)
          errNoti = { id: `copy-${oldPath}`, title: 'Moving Large File ', message: `File ${oldPath} is taking longer than 30 seconds to move.  Please use the search page after a few minutes to check if the move has completed successfully.` };
        else
          errNoti = { id: `copy-${oldPath}`, title: 'Move Failed', message: `Failed during move for file ${oldPath}` };
        await this.props.notiActions.add(errNoti);
        continue
      }

      noti.message = `${i+1}/${files.length} files moved`;
      noti.progress = 100.0 * (i + 1) / files.length;
      noti.status = 'updating';
      await this.props.notiActions.update(noti);
    }
    noti.title = 'Moved Files';
    noti.status = 'done';
    await this.props.notiActions.update(noti);
  }

  render = () => {
    return (
      <form onSubmit={this.handleFormSubmit}>
        <Container>
        <br/>
          <Grid container spacing={2}>
            <Grid container item xs={7} spacing={2}>
              <FormControl className="w-100 m-1 mb-4">
                <FolderTree onInit={this.folderOnInit} onSelect={this.folderOnSelect} />
              </FormControl>
            
              <Button className="mr-2" type="submit" variant="contained">Move</Button>
            </Grid>

            <Grid item xs={5}>
              <div className={css.bold}>Selected Files:</div>
              <div>
                {this.state.files && this.state.files.map((file, index) =>
                  <div key={index}>{file.path}</div>
                )}
              </div>
            </Grid>
          </Grid>
        </Container>
        { this.state.done ? <Redirect to="/search" /> : null }
      </form>
    );
  }
}

export default withRouter(Move);